import React from 'react';

export default function RegisterTeamModal({ open, onClose, children, title = 'Create Your Team' }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1000]">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* panel (top-aligned, centered) */}
      <div
        className="absolute left-1/2 -translate-x-1/2"
        style={{
          top: '72px',                          // aligns near top of columns
          width: '400px',                        // requested width
          maxWidth: '95vw',
          maxHeight: 'calc(100vh - 96px)',       // keep inside viewport
        }}
      >
        <div className="bg-white rounded-2xl shadow-[0_12px_40px_rgba(0,0,0,0.18)] overflow-hidden border border-[#00aef7]">
          {/* header */}
          <div className="flex items-center justify-between px-4 py-3 bg-[#00aef7] text-white">
            <h3 className="text-lg font-semibold">{title}</h3>
            <button
              type="button"
              onClick={onClose}
              className="rounded-md px-2 py-1 hover:bg-white/10"
              aria-label="Close"
              title="Close"
            >
              ✕
            </button>
          </div>

          {/* body (scrollable if it grows with suggestions) */}
          <div className="px-4 py-4 overflow-auto" style={{ maxHeight: 'calc(100vh - 160px)' }}>
            {children /* we will progressively move the form pieces in next steps */}
          </div>
        </div>
      </div>
    </div>
  );
}
